import {usePage} from "@inertiajs/vue3";

export default function (action, user = null) {
    const titles = {
        approve: 'согласовал(-а)',
        sign: 'подписал(-а)',
        revoke: 'отозвал(-а)',
        rework: 'отправил(-а) на доработку',
        decline: 'отказал(-а)'
    }
    const youTitles = {
        approve: 'согласовали',
        sign: 'подписали',
        revoke: 'отозвали',
        rework: 'отправили на доработку',
        decline: 'отказали'
    }

    let usedTitles = user?.id === usePage().props.auth.user.id ? youTitles : titles;
    if (action in usedTitles) {
        return usedTitles[action];
    }
    return action;
}
